import { AssignedWorkAreaDto, CarrierVisitAssignmentDto } from '@operations/app/api'
import { getYardBlockNameWithAssignedBays } from '@operations/utils/yard-block'

export const getYardAssignmentText = (assignments: AssignedWorkAreaDto[]) => {
  const distinctYards = assignments.reduce<{ id: string; name: string; assignedBays: string[] }[]>(
    (result, item) => {
      if (item.yardBlock?.id && !result.some(x => x.id === item.yardBlock?.id)) {
        result.push({
          id: item.yardBlock.id,
          name: item.yardBlock.name,
          assignedBays: item.assignedBays,
        })
      }
      return result
    },
    [],
  )

  const blocks = distinctYards.map(x => getYardBlockNameWithAssignedBays(x))

  return blocks.join('; ')
}

export const getCarrierAssignments = (assignments: AssignedWorkAreaDto[]) => {
  return assignments.reduce<CarrierVisitAssignmentDto[]>((result, item) => {
    if (item.carrierVisit?.id && !result.some(x => x.id === item.carrierVisit?.id)) {
      result.push(item.carrierVisit)
    }
    return result
  }, [])
}
